export const fullAccess = `<single-spa-router>
        <div class="globalnav">
          <application name="@Nav" props="userProfile,mfeConfig"></application>
        </div>
        <div id="main" class="router-outlet">
          <div id="authentication-error-screen"></div>
          <div id="unauthorized-screen"></div>
          <route exact path="/">
            <div class="dashboard">
              <div id="dashboard-page-title"></div>
              <div class="cards">
                <application name="@Seniority" props="userProfile"></application>
                <application name="@My-hours" props="userProfile"></application>
              </div>
              <div id="quick-links-card-container"></div>
            </div>
          </route>
          <route path="Seniority">
            <application name="@Seniority" props="userProfile"></application>
          </route>
          <route path="My-hours">
            <application name="@My-hours" props="userProfile"></application>
          </route>
           <route path="overtime-requests">
            <application name="@OtRequestManagement" props="userProfile"></application>
          </route>
           <route path="overtime-intake">
            <application name="@OtRequestManagement" props="userProfile"></application>
          </route>
                    <route path="myotcs">
            <application name="@OtEmployeeSignup" props="userProfile"></application>
          </route>
          <route path="ot-hours">
            <application name="@ot-hours" props="userProfile"></application>
          </route>
          <route path="bid-lines">
            <application name="@bid-lines" props="userProfile"></application>
          </route>
          <route path="exceptions">
            <application name="@exceptions" props="userProfile"></application>
          </route>
          <route path="vacancy">
            <application name="@vacancy" props="userProfile"></application>
          </route>
          <route path="reports">
            <application name="@reports" props="userProfile"></application>
          </route>
        </div>
      </single-spa-router>`;

export const limitedAccess = `<single-spa-router>
        <div class="globalnav">
          <application name="@Nav" props="userProfile,mfeConfig"></application>
        </div>
        <div id="main" class="router-outlet">
          <div id="authentication-error-screen"></div>
          <div id="unauthorized-screen"></div>
          <route exact path="/">
            <div class="dashboard">
              <div id="dashboard-page-title"></div>
              <div class="cards">
                <application name="@Seniority" props="userProfile"></application>
                <application name="@My-hours" props="userProfile"></application>
              </div>
              <div id="quick-links-card-container"></div>
            </div>
          </route>
          <route path="Seniority">
            <application name="@Seniority" props="userProfile"></application>
          </route>
          <route path="My-hours">
            <application name="@My-hours" props="userProfile"></application>
          </route>
          <route path="bid-lines">
            <application name="@bid-lines" props="userProfile"></application>
          </route>
          <route path="vacancy">
            <application name="@vacancy" props="userProfile"></application>
          </route>
        </div>
      </single-spa-router>`;

export const unAuthorizedLayout = `<single-spa-router>
      <div id="main" class="router-outlet">
        <div id="authentication-error-screen"></div>
        <div id="unauthorized-screen"></div>
      </div>
    </single-spa-router>`;
